module.exports = __webpack_public_path__ + "static/media/heatherbook.f0bca209.png";